exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".glasses[data-v-29415b98] {\n  /* From https://css.glass */\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  position: absolute;\n}\n.scattered-previews[data-v-29415b98] {\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n", ""]);

// exports
